<template lang="pug">
  tr(:class="{ active: loading }")
    td.text-small {{ referenceMonth }}
    td.tooltip.tooltip-top(:data-tooltip="balance.filiation.person.fullName" style="max-width: 150px;")
      .text-ellipsis.text-small {{ balance.filiation.person.fullName }}
    td
      small.label-rounded(:class="statusAttrs.class") {{ balance.status | balanceStatus }}
    td.text-small {{ balance.updatedAt | toDate('DD/MM/YYYY [as] HH:mm') }}
    td.text-right {{ subscriptionsMonetization.amount | currency('R$ ') }}
    td.text-right {{ purchasesMonetization.amount | currency('R$ ') }}
    td.text-right {{ videoWatchesMonetization.amount | currency('R$ ') }}
    td.text-right
      .text-bold.text-success {{ balance.amount | currency('R$ ') }}
    td.text-right
      .btn.btn-action.btn-primary.btn-sm.loading.disabled(v-if="loading")
      actions(v-else :balance="balance" @refreshBalance="onRefresh")
</template>

<script>
import moment from 'moment'
import { mapBalanceStatus } from '@/lib/constants'
import Actions from './RowActions'
import filiationBalances from '@/services/filiationBalances'

export default {
  props: { balance: { type: Object, required: true } },
  components: { Actions },
  data() {
    return { loading: false }
  },
  computed: {
    referenceMonth() {
      return moment(this.balance.month)
        .utc()
        .format('MM [de] YYYY')
    },
    subscriptionsMonetization() {
      return this.balance.monetizations.find(i => i.type === 'subscription')
    },
    purchasesMonetization() {
      return this.balance.monetizations.find(i => i.type === 'purchase')
    },
    videoWatchesMonetization() {
      return this.balance.monetizations.find(i => i.type === 'video_watch')
    },
    statusAttrs() {
      return mapBalanceStatus[this.balance.status]
    },
  },
  methods: {
    confirm(message, config = {}) {
      const options = {
        size: 'sm',
        title: 'Confirmar',
        cancelLabel: 'Cancelar',
        ...config,
      }
      return this.$dialogs.confirm(message, options)
    },
    async onRefresh(balance) {
      const { ok } = await this.confirm('Deseja recalcular este balanço?')
      if (!ok) return
      try {
        this.loading = true
        const { data } = await filiationBalances.refresh(balance.id)
        this.$emit('updated', data)
        this.$toaster.success('Balanço recalculado!')
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
